import React from 'react';

/**
 * Safely gets a renderable output of most given values.
 */
const FALLBACK_VALUE = null;

export const renderChildren = (child: any, props = {}) => {
    let rendered = child;

    const mergedProps = {
        ...(rendered ? rendered.props : {}),
        ...props,
    };
    if (React.isValidElement(rendered)) {
        return React.cloneElement(rendered, mergedProps);
    }

    if (typeof child === 'function') {
        rendered = child(mergedProps);
    }

    if (['undefined', 'boolean'].includes(typeof rendered)) {
        return FALLBACK_VALUE;
    }

    return rendered;
};
